module.exports = __webpack_public_path__ + "img/librarybg1.f0a9c262.png";